import Select from "../../ui-components/Select";
import { useIntl } from "react-intl";

import {
  SORT_OPTIONS_TASKS,
  WORKSITE_TASK_STATUS_OPTIONS,
} from "../../utils/constants";

export const TaskListingFilters = ({ filters, setFilters }) => {
  const intl = useIntl();

  return (
    <div className="flex gap-3 w-full md:w-auto">
      <div className="flex-1">
        <Select
          className={"w-auto ml-auto"}
          value={filters.taskStatus}
          options={[
            {
              name: intl.formatMessage({ id: "tasks_status" }),
              value: "",
            },
          ].concat(
            WORKSITE_TASK_STATUS_OPTIONS.map((o) => ({
              ...o,
              name: intl.formatMessage({ id: o.name }),
            }))
          )}
          onChange={(e) => {
            setFilters({ ...filters, taskStatus: e.target.value });
          }}
        />
      </div>
      <div className="flex-1">
        <Select
          className={"w-auto"}
          value={filters.sortMode}
          options={[
            {
              name: intl.formatMessage({ id: "tasks_sort_choose" }),
              value: "",
            },
          ].concat(
            SORT_OPTIONS_TASKS.map((o) => ({
              ...o,
              name: intl.formatMessage({ id: o.name }),
            }))
          )}
          onChange={(e) => {
            setFilters({ ...filters, sortMode: e.target.value });
          }}
        />
      </div>
    </div>
  );
};

export default TaskListingFilters;
